import { AnimatedParam } from '../../tools/viewtransitions/ViewTransition';

export class AnimatedVisibility {
	container;
	showStyle;
	param;

	constructor(container, initValue, animTime = 0.5, showStyle = 'block') {
		this.container = container;
		this.showStyle = showStyle;
		this.param = new AnimatedParam(initValue, (a) => {
			if (a > 0 && a < 1) {
				this.container.style.opacity = a;
				return;
			}

			// unset if either fully visible or invisible, display style will take over.
			this.container.style.opacity = '';
			// If visible, then we pre-set the display style no need to change.
			if (a === 0) this.container.style.display = 'none';
		}, animTime);
	}

	/**
	 * Animates the change in visibility of the container
	 * @param {number|boolean} visibility Either {true, false} or the final opacity value [0.0, 1.0]
	 */
	fadeTo(visibility) {
		const fractionVisible = Number(visibility);
		const endsVisible = fractionVisible > 0;

		if (this.valueOf()) {
			if (endsVisible) {
				this.param.fadeTo(fractionVisible);
			} else {
				this.param.fadeTo(0.0);
			}
		} else {
			if (endsVisible) {
				this.container.style.display = this.showStyle;
				this.param.curValue = 1E-6; // for valueOf before the first frame of `fadeTo`.
				this.param.fadeTo(fractionVisible);
			} else {
				// NOOP from hidden to hidden
			}
		}
	}

	/** Immediate visibility */
	valueOf() {
		return this.param.curValue > 0;
	}

	/** Eventual visibility, in case it's different from immediate (when animating) */
	targetValue() {
		return this.param.targetValue > 0;
	}
}